<!--
 ECHARTS 的 饼图
-->
<template>
  <!-- 250px -->
  <div :id="comID" :style="pieStyle"></div>
</template>

<script>
  // 按需引入
  import 'echarts/lib/component/tooltip';
  import 'echarts/lib/component/legend';
  import 'echarts/lib/component/grid';

  import * as echarts from 'echarts/lib/echarts';
  import {
    GridComponent
  } from 'echarts/components';
  echarts.use([GridComponent]);

  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  export default {
    props: {
      // ID
      comID: {
        type: String,
        default: 'myChart_bar'
      },
      // 高度
      comHeight: {
        type: Number,
        default: 400
      },
      // 数据
      comData: {
        type: Array,
        default: () => {
          return [];
        }
      },
    },
    data() {
      return {
        // 用于计算高度
        pieStyle: '',
        items: [],
        legendData: [],
        xAxisData: [],
        series: [],
      };
    },
    created() {
      let that = this;
      that.pieStyle = 'width: 100%; height:' + (that.comHeight * 0.0625) + 'rem;';

      that.legendData = [];
      that.xAxisData = [];
      that.series = [];
      that.items = that.comData;
      that.items.forEach(element => {
        that.legendData.push(element.collegeName);
        var it = {
          name: element.collegeName,
          type: 'bar',
          emphasis: {
            focus: 'series'
          },
          data: [],
        }
        element.leaveList.forEach(leave => {
          it.data.push(leave.number);
        })
        that.series.push(it);
      })

      that.items[0].leaveList.forEach(element => {
        that.xAxisData.push(element.name);
      })
      console.log("items", that.items)

      that.$nextTick(() => {
        that.drawLine();
      });
    },
    mounted() {
      let that = this;
      window.onresize = function() {
        // that.myChart.resize();
        that.pieStyle = 'width: 100%; height:' + (that.comHeight * 0.0625) + 'rem;';
      }
    },
    methods: {

      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById(this.comID));

        const labelOption = {
          show: true,
          position: 'insideBottom',
          distance: 10,
          align: 'left',
          verticalAlign: 'middle',
          rotate: 90,
          formatter: '{c}',
          // formatter: '{c}  {name|{a}}',
          fontSize: 16,
          rich: {
            name: {}
          }
        };


        // 绘制图表
        myChart.setOption({
          grid: {
            top: '15%',
            left: '1%',
            right: '0%',
            bottom: '5%'

          },
          legend: {},
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: this.legendData
          },
          xAxis: {
            type: 'category',
            axisTick: {
              show: false
            },
            data: this.xAxisData,
          },
          yAxis: {
            type: 'value'
          },
          series: this.series
        });
      }
    },
    watch: {
      comData() {
        let that = this;
        that.legendData = [];
        that.xAxisData = [];
        that.series = [];
        that.items = that.comData;
        that.items.forEach(element => {
          that.legendData.push(element.collegeName);
          var it = {
            name: element.collegeName,
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: [],
          }
          element.leaveList.forEach(leave => {
            it.data.push(leave.number);
          })
          that.series.push(it);
        })

        that.items[0].leaveList.forEach(element => {
          that.xAxisData.push(element.name);
        })

        that.$nextTick(() => {
          that.drawLine();
        });
      }
    }
  };
</script>

<style>

</style>
